'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lodash = require('lodash');

var _decisivUiUtils = require('decisiv-ui-utils');

var _arrow = require('../../utils/arrow');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_BASE = _constants2.default.ARROW_BASE,
    ARROW_HEIGHT = _constants2.default.ARROW_HEIGHT,
    ARROW_OFFSET = _constants2.default.ARROW_OFFSET,
    BOTTOM_ROTATE = _constants2.default.BOTTOM_ROTATE,
    LEFT_ROTATE = _constants2.default.LEFT_ROTATE,
    RIGHT_ROTATE = _constants2.default.RIGHT_ROTATE,
    TOP_ROTATE = _constants2.default.TOP_ROTATE;

/**
 * Attempt to get the correct background color from the provided
 * `arrowColor`. If `arrowColor` is a valid key in `theme.colors.status`,
 * use the value there; otherwise use the given `arrowColor` directly,
 * assuming that it is a valid CSS color. The default fallback will
 * be the theme base background color.
 * @param theme {object}
 * @param arrowColor {string}
 * @return {string}
 */

function backgroundFor(theme, arrowColor) {
  var defaultColor = theme.colors.base.background;
  var color = (0, _lodash.get)(theme, ['colors', 'status', arrowColor], arrowColor);
  return (0, _arrow.setBackground)(defaultColor, color);
}

var modifierConfig = {
  bottom: function bottom(_ref) {
    var arrowColor = _ref.arrowColor,
        theme = _ref.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomLeft: function bottomLeft(_ref2) {
    var arrowColor = _ref2.arrowColor,
        theme = _ref2.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    right: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomRight: function bottomRight(_ref3) {
    var arrowColor = _ref3.arrowColor,
        theme = _ref3.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  left: function left(_ref4) {
    var arrowColor = _ref4.arrowColor,
        theme = _ref4.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    margin: auto;\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: 0;\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  leftBottom: function leftBottom(_ref5) {
    var arrowColor = _ref5.arrowColor,
        theme = _ref5.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  leftTop: function leftTop(_ref6) {
    var arrowColor = _ref6.arrowColor,
        theme = _ref6.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  right: function right(_ref7) {
    var arrowColor = _ref7.arrowColor,
        theme = _ref7.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    margin: auto;\n    top: 0;\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  rightBottom: function rightBottom(_ref8) {
    var arrowColor = _ref8.arrowColor,
        theme = _ref8.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  rightTop: function rightTop(_ref9) {
    var arrowColor = _ref9.arrowColor,
        theme = _ref9.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  top: function top(_ref10) {
    var arrowColor = _ref10.arrowColor,
        theme = _ref10.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  },

  topLeft: function topLeft(_ref11) {
    var arrowColor = _ref11.arrowColor,
        theme = _ref11.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    right: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  },

  topRight: function topRight(_ref12) {
    var arrowColor = _ref12.arrowColor,
        theme = _ref12.theme;
    return '\n    background: ' + backgroundFor(theme, arrowColor) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n  position: absolute;\n  width: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Popover__Arrow', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Popover/Arrow.js
// module id = 1684
// module chunks = 2